import { LastMinuteCancellation } from 'pages/ReportsPage/components/AnalyticsDashboards/FulfillmentDashboard/store/fulfillmentDashboard.store.types';

export const LAST_MINUTE_CANCELLATIONS_STUB: LastMinuteCancellation[] = [
  {
    date: 'May 05',
    shiftId: 'Shift #203988',
    location: 'Seasons Amherstburg',
    position: 'Resident Care Partner (PSW)',
    timeframe: 'Morning',
    cancelledBy: 'Team Member',
    teamMember: 'Dina Marcos',
    hoursBeforeStart: '1.1h',
  },
  {
    date: 'May 05',
    shiftId: 'Shift #203991',
    location: 'Seasons Cambridge',
    position: 'Wellness Nurse',
    timeframe: 'Evening',
    cancelledBy: 'Scheduler',
    teamMember: '—',
    hoursBeforeStart: '3.5h',
  },
  {
    date: 'May 05',
    shiftId: 'Shift #203995',
    location: 'Seasons Owen Sound',
    position: 'Server',
    timeframe: 'Overnight',
    cancelledBy: 'Team Member',
    teamMember: 'Precious Osei',
    hoursBeforeStart: '0.7h',
  },
  {
    date: 'May 06',
    shiftId: 'Shift #204002',
    location: 'Seasons Belle River',
    position: 'Housekeeper',
    timeframe: 'Morning',
    cancelledBy: 'Team Member',
    teamMember: 'Claudia Torres',
    hoursBeforeStart: '2.2h',
  },
  {
    date: 'May 06',
    shiftId: 'Shift #204008',
    location: 'Seasons Camrose',
    position: 'Concierge',
    timeframe: 'Morning',
    cancelledBy: 'Scheduler',
    teamMember: '—',
    hoursBeforeStart: '1.6h',
  },
  {
    date: 'May 06',
    shiftId: 'Shift #204011',
    location: 'Seasons Strathroy',
    position: 'Resident Care Partner (PSW)',
    timeframe: 'Evening',
    cancelledBy: 'Team Member',
    teamMember: 'Helen Nwosu',
    hoursBeforeStart: '0.9h',
  },
  {
    date: 'May 06',
    shiftId: 'Shift #204015',
    location: 'Seasons Wesbrook',
    position: 'Medication Care Partner',
    timeframe: 'Overnight',
    cancelledBy: 'Scheduler',
    teamMember: '—',
    hoursBeforeStart: '3.2h',
  },
  {
    date: 'May 07',
    shiftId: 'Shift #204019',
    location: 'Seasons Arbutus',
    position: 'Wellness Nurse',
    timeframe: 'Morning',
    cancelledBy: 'Team Member',
    teamMember: 'Nadia Petrov',
    hoursBeforeStart: '0.6h',
  },
  {
    date: 'May 07',
    shiftId: 'Shift #204023',
    location: 'Seasons Amherstburg',
    position: 'Cook',
    timeframe: 'Evening',
    cancelledBy: 'Team Member',
    teamMember: 'James Okafor',
    hoursBeforeStart: '2.9h',
  },
  {
    date: 'May 07',
    shiftId: 'Shift #204026',
    location: 'Seasons Owen Sound',
    position: 'Resident Care Partner (PSW)',
    timeframe: 'Overnight',
    cancelledBy: 'Scheduler',
    teamMember: '—',
    hoursBeforeStart: '1.4h',
  },
  {
    date: 'May 08',
    shiftId: 'Shift #204031',
    location: 'Seasons Camrose',
    position: 'Resident Care Partner (PSW)',
    timeframe: 'Morning',
    cancelledBy: 'Team Member',
    teamMember: 'Alyssa Sumonja',
    hoursBeforeStart: '0.4h',
  },
  {
    date: 'May 08',
    shiftId: 'Shift #204034',
    location: 'Seasons Cambridge',
    position: 'Server',
    timeframe: 'Evening',
    cancelledBy: 'Team Member',
    teamMember: 'Rachel Fung',
    hoursBeforeStart: '3.9h',
  },
  {
    date: 'May 08',
    shiftId: 'Shift #204041',
    location: 'Seasons Belle River',
    position: 'Life Enrichment Assistant',
    timeframe: 'Morning',
    cancelledBy: 'Scheduler',
    teamMember: '—',
    hoursBeforeStart: '2.7h',
  },
  {
    date: 'May 09',
    shiftId: 'Shift #204047',
    location: 'Seasons Strathroy',
    position: 'Housekeeper',
    timeframe: 'Evening',
    cancelledBy: 'Team Member',
    teamMember: 'Tomas Ruiz',
    hoursBeforeStart: '1.2h',
  },
  {
    date: 'May 09',
    shiftId: 'Shift #204052',
    location: 'Seasons Wesbrook',
    position: 'Wellness Nurse',
    timeframe: 'Overnight',
    cancelledBy: 'Team Member',
    teamMember: 'Grace Adeyemi',
    hoursBeforeStart: '0.8h',
  },
  {
    date: 'May 09',
    shiftId: 'Shift #204058',
    location: 'Seasons Arbutus',
    position: 'Maintenance Assistant',
    timeframe: 'Morning',
    cancelledBy: 'Scheduler',
    teamMember: '—',
    hoursBeforeStart: '3.6h',
  },
  {
    date: 'May 10',
    shiftId: 'Shift #204063',
    location: 'Seasons Amherstburg',
    position: 'Medication Care Partner',
    timeframe: 'Evening',
    cancelledBy: 'Team Member',
    teamMember: 'Marcus Bell',
    hoursBeforeStart: '2.1h',
  },
  {
    date: 'May 10',
    shiftId: 'Shift #204069',
    location: 'Seasons Owen Sound',
    position: 'Concierge',
    timeframe: 'Morning',
    cancelledBy: 'Team Member',
    teamMember: 'Priya Nair',
    hoursBeforeStart: '0.5h',
  },
  {
    date: 'May 10',
    shiftId: 'Shift #204074',
    location: 'Seasons Camrose',
    position: 'Cook',
    timeframe: 'Overnight',
    cancelledBy: 'Scheduler',
    teamMember: '—',
    hoursBeforeStart: '1.9h',
  },
  {
    date: 'May 11',
    shiftId: 'Shift #204081',
    location: 'Seasons Cambridge',
    position: 'Resident Care Partner (PSW)',
    timeframe: 'Morning',
    cancelledBy: 'Team Member',
    teamMember: 'Owen Fletcher',
    hoursBeforeStart: '3.3h',
  },
  {
    date: 'May 11',
    shiftId: 'Shift #204088',
    location: 'Seasons Belle River',
    position: 'Server',
    timeframe: 'Evening',
    cancelledBy: 'Team Member',
    teamMember: 'Sofia Almeida',
    hoursBeforeStart: '0.3h',
  },
  {
    date: 'May 11',
    shiftId: 'Shift #204093',
    location: 'Seasons Strathroy',
    position: 'Wellness Nurse',
    timeframe: 'Overnight',
    cancelledBy: 'Scheduler',
    teamMember: '—',
    hoursBeforeStart: '2.4h',
  },
  {
    date: 'May 12',
    shiftId: 'Shift #204099',
    location: 'Seasons Wesbrook',
    position: 'Housekeeper',
    timeframe: 'Morning',
    cancelledBy: 'Team Member',
    teamMember: 'Daniel Kim',
    hoursBeforeStart: '1.7h',
  },
  {
    date: 'May 12',
    shiftId: 'Shift #204104',
    location: 'Seasons Arbutus',
    position: 'Life Enrichment Assistant',
    timeframe: 'Evening',
    cancelledBy: 'Team Member',
    teamMember: 'Emily Watson',
    hoursBeforeStart: '0.9h',
  },
];
